import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HTTPService } from 'app/services';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-gallery-modal',
  templateUrl: './gallery-modal.component.html',
  styleUrls: ['./gallery-modal.component.scss']
})
export class GalleryModalComponent implements OnInit {

  screenSize: { width: number; height: number } = {
    width: window.innerWidth,
    height: window.innerHeight,
  };

  mediaFiles: string[] = [];
  selectedInspectionId: string = '';
  selectedItemId: string = '';
  isRemovingAllowed: boolean = false;
  isPreviewLoading: boolean = false;
  containerWidth: number = 0;
  containerHeight: number = 0;
  config = {
    btnClass: 'default',
    zoomFactor: 0.1,
    containerBackgroundColor: '#252828',
    wheelZoom: true,
    allowFullscreen: true,
    allowKeyboardNavigation: true,
    btnIcons: {
      zoomIn: 'fal fa-plus',
      zoomOut: 'fal fa-minus',
      fullscreen: 'fa-expand fal',
    },
    btnShow: {
      zoomIn: true,
      zoomOut: true,
      next: false,
      prev: false,
    },
    customBtns: []
  };
  selectedFile;
  inspection;
  currentLang: string = 'en';
  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private httpService: HTTPService,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    const { mediaFiles, selectedInspectionId, inspection, isRemovingAllowed, selectedItemId, currentLang = 'en' } = this.dialogConfig.data;
    this.currentLang = currentLang;
    this.translate.use(this.currentLang);
    this.mediaFiles = mediaFiles;
    this.selectedInspectionId = selectedInspectionId;
    this.selectedItemId = selectedItemId;
    this.inspection = inspection;
    this.isRemovingAllowed = isRemovingAllowed;
    this.selectedFile = mediaFiles[this.selectedItemId ? mediaFiles.findIndex(media => media._id === this.selectedItemId) : 0];
    this.updateScreenSize();
  }

  private updateScreenSize(): void {
    this.screenSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  selectMedia(media) {
    this.isPreviewLoading = true;
    setTimeout(() => {
      this.selectedFile = { ...media };
      this.isPreviewLoading = false;
    }, 0);
  }

  removeMedia(media) {
    let isChanged = false;
    for (const ins of this.inspection.category) {
      const targetInspection = ins.inspectionItems.findIndex(i => i._id === this.selectedInspectionId);
      if (targetInspection > -1) {
        this.mediaFiles = ins.inspectionItems[targetInspection].attachments.filter(attachment =>
          attachment.url !== media.url && (attachment.type === 'image' || attachment.type === 'video')
        );
        ins.inspectionItems[targetInspection].attachments = ins.inspectionItems[targetInspection].attachments.filter(attachment => (attachment.url !== media.url));
        isChanged = true;
        break;
      }
    }
    if (isChanged) {
      this.httpService.updateOrderInspection(this.inspection)
      if (!this.mediaFiles?.length) {
        this.handleClose()
      } else {
        this.selectedFile = this.mediaFiles[0];
      }
    }
  }

  handleClose() {
    this.dynamicDialogRef.close({
      mediaFiles: this.mediaFiles
    });
  }
}
